"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
// tslint:disable-next-line: arrow-return-shorthand
exports.modalTheme = function (theme) {
    var componentTheme = {
        boxShadow: '0 0 50px 0 rgba(0, 0, 0, 0.3)',
        margin: '5rem',
        content: {
            background: theme.base.color.normal,
            color: theme.base.color.text,
            padding: theme.global.spacer.medium,
        },
        header: {
            background: theme.base.color.normal,
            border: "0.063rem solid " + theme.greyNormal.color.normal,
        },
        headline: {
            padding: theme.global.spacer.small,
        },
        button: {
            padding: theme.global.spacer.small,
            backgroundHighlight: theme.greyNormal.color.normal,
        },
        footer: {
            background: theme.base.color.normal,
            border: 'none',
            margin: theme.global.spacer.medium,
            padding: theme.global.spacer.medium,
        },
    };
    if (theme.component.modal) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.modal);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { modal: componentTheme }) });
};
exports.modalThemeWithBackground = function (theme) {
    var componentTheme = {
        boxShadow: '0 0 50px 0 rgba(0, 0, 0, 0.3)',
        margin: '5rem',
        content: {
            background: theme.greyLight.color.normal,
            color: theme.greyLight.color.text,
            padding: theme.global.spacer.medium,
        },
        header: {
            background: theme.base.color.normal,
            border: "0.063rem solid " + theme.greyNormal.color.normal,
        },
        headline: {
            padding: theme.global.spacer.small,
        },
        button: {
            padding: theme.global.spacer.small,
            backgroundHighlight: theme.greyNormal.color.normal,
        },
        footer: {
            background: theme.base.color.normal,
            border: 'none',
            margin: theme.global.spacer.medium,
            padding: theme.global.spacer.medium,
        },
    };
    if (theme.component.modal) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.modal);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { modal: componentTheme }) });
};
exports.default = exports.modalTheme;
//# sourceMappingURL=theme.js.map